import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import { FilterTypeLegacy } from '@verantos-dev/types-cohorts';

import {
  addActiveCohortBuilderItemFilter,
  deleteActiveCohortBuilderItemFilter,
} from '../cohortBuilderSlice';
import { selectActiveCohortBuilderItemRelatedEntityFilters } from '../selectors/cohortBuilderEditModalSelectors';

export const useRelatedEntityFilters = () => {
  const dispatch = useAppDispatch();
  const relatedEntityFilters =
    useAppSelector(selectActiveCohortBuilderItemRelatedEntityFilters) ?? [];

  const onAddRelatedEntityFilterClick = () => {
    dispatch(addActiveCohortBuilderItemFilter(FilterTypeLegacy.RELATED_ENTITY));
  };

  const onDeleteRelatedEntityFilterClick = (id: string) => {
    dispatch(
      deleteActiveCohortBuilderItemFilter({
        filterId: id,
        filterType: FilterTypeLegacy.RELATED_ENTITY,
      })
    );
  };

  return {
    relatedEntityFilters,
    onAddRelatedEntityFilterClick,
    onDeleteRelatedEntityFilterClick,
  };
};
